const daysInMilliseconds = 86400000;

type InputDate = Date | string | null | undefined;

const daysDifferenceUtil = (date1: InputDate, date2: InputDate): number | null => {
  if (!date1 || !date2) {
    return null;
  }

  date1 = new Date(date1);
  date2 = new Date(date2);

  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
    return null;
  }

  const diffTime = Math.abs(date2.getTime() - date1.getTime());

  return Math.ceil(diffTime / daysInMilliseconds);
};

export default daysDifferenceUtil;
